import {
  create,
  toDataURL,
  toBuffer,
  getSvgDataURL,
  toString,
  getSvg,
} from '../lib/index';

const cnfQrocde = {
  create,
  toDataURL,
  toBuffer,
  getSvgDataURL,
  toString,
  getSvg
};

export {
  create,
  toDataURL,
  toBuffer,
  getSvgDataURL,
  toString,
  getSvg
};

export default cnfQrocde;
